import * as Yup from 'yup';

const transactionFilterSchema = Yup.object({
    start_date: Yup.string()
        // .test('dob', 'Invalid start date', function (value) {
        //     return value && !isNaN(new Date(value).getTime());
        // })
        .nullable()
        .notRequired(),
    end_date: Yup.string()
        .nullable()
        // .test('dob', 'Invalid end date', function (value) {
        //     return value && !isNaN(new Date(value).getTime());
        // })
        .notRequired(),
    uuid_venue: Yup.array()
        .notRequired(),
    uuid_user: Yup.array()
        .notRequired(),
    status: Yup.array()
        .notRequired(),
    transfer_status: Yup.array()
        .notRequired(),
    booking_type: Yup.array()
        .notRequired()
});

export default transactionFilterSchema;